import React, { useEffect, useState } from "react";
import { Spacer, Text, SubTitle } from "@dspworkplace/ui";
import { useAuth } from "../../../../Auth";
import Modal from "../../../../components/Modal";
import { HelpButton } from "../../../../components/UI";
import { checkIfAnyPayrollAccountIsActive } from "./api";
import Loading, { LoadingWrapper } from "../../../../components/Loading";
import PunchRemindersActivePayroll from "./PunchRemindersActivePayroll";
import PunchRemindersInactivePayroll from "./PunchRemindersInactivePayroll";

const PunchReminders = () => {

    const { api } = useAuth();
    const [payrollStatus, setPayrollStatus] = useState({ active: false, isLoading: true });
    const [showHelp, setShowHelp] = useState(false);

    useEffect(() => {

        let ignore = false;

        const checkPayrollAccount = async () => {

            const resp = await checkIfAnyPayrollAccountIsActive(api);

            if (ignore) return;

            setPayrollStatus({ active: resp, isLoading: false });

        }

        checkPayrollAccount();

        return () => {
            ignore = true;
        };

    }, [api])

    const showActivePayroll = payrollStatus.active && !payrollStatus.isLoading;

    return (
        <div style={{ position: "relative" }}>
            <SubTitle>
                Punch Reminders
                <HelpButton onClick={() => setShowHelp(true)}>How Does It Work?</HelpButton>
            </SubTitle>
            <Spacer bottom={5} />
            {showActivePayroll ? <PunchRemindersActivePayroll /> : <PunchRemindersInactivePayroll />}
            {payrollStatus.isLoading && (
                <LoadingWrapper>
                    <Loading />
                </LoadingWrapper>
            )}
            {showHelp && (
                <Modal
                    visible={true}
                    setVisible={() => setShowHelp(false)}
                    title="Punch Reminders"
                    drawer={"right"}
                >
                    <Text>
                        Punch Reminders help drivers stay payroll compliant by sending automatic alerts when a
                        required punch appears to be missing. Configure reminders for Punch In, Break In, Break Out,
                        and Punch Out, choose Chat, SMS, or both, set the delay and resend frequency, and enable
                        them globally or per station. Reminders stop automatically once the required punch is
                        detected or the maximum retry limit is reached.
                    </Text>
                    <Spacer bottom={5} />
                </Modal>
            )}
        </div>
    );

}

export default PunchReminders;
